import React from 'react';
import PropTypes from 'prop-types';
import './styles.styl';

const Intro = ({ title, lead, direction, img, imgAlt }) => (
  <div className="intro">
    {title && <h1>{title}</h1>}
    {lead && <p className="intro__lead">{lead}</p>}
    {direction && <p className="intro__direction">{direction}</p>}
    {img && (
      <img
        className="intro__img"
        src={img}
        alt={imgAlt}
        height="235"
        width="568"
      />
    )}
  </div>
);

Intro.defautProps = {
  imgAlt: ''
};

Intro.propTypes = {
  title: PropTypes.string,
  lead: PropTypes.node,
  direction: PropTypes.string,
  img: PropTypes.string,
  imgAlt: PropTypes.string
};

export default Intro;



// WEBPACK FOOTER //
// ../core/src/components/Intro/index.js